export default "__VITE_ASSET__70231f5e__"